import React from 'react';
import {
  useThemeProvider,
  DefaultThemeConfig,
  DragAndDropProvider,
  ThemeContext,
} from '@di-nxt/components';
import {Navigator} from './navigation';
import {useUserAppearance} from './navigation/hooks/useUserAppearence';

export function ThemedApp() {
  const {darkmode} = useUserAppearance();
  const theme = useThemeProvider(darkmode, DefaultThemeConfig);
  return (
    <ThemeContext.Provider value={theme}>
      <DragAndDropProvider>
        <Navigator />
      </DragAndDropProvider>
    </ThemeContext.Provider>
  );
}
